import React from 'react';
import LogoHeader from './LogoHeader';
import MenuHeader from './MenuHeader';
import BtnHeader from './ButtonHeader';

function Header() {
  return (
    <>
      <div className="w-full sticky top-0 bg-header z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-end h-20">
            <div className="py-2 w-2/12">
              <LogoHeader />
            </div>
            <div className="text-center w-8/12">
              <MenuHeader />
            </div>
            <div className="w-2/12 flex justify-end">
              <BtnHeader />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
